// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file shared_parameter_service.proto (package pipeex.sharedparameter.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ParameterDataTypeHint, StartOperationResponseSchema } from "./revit_service_pb";
import { file_revit_service } from "./revit_service_pb";
import type { ProjectParameterUndoEntry } from "./parameter_undo_pb";
import { file_parameter_undo } from "./parameter_undo_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file shared_parameter_service.proto.
 */
export const file_shared_parameter_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_revit_service, file_parameter_undo]);

/**
 * @generated from message pipeex.sharedparameter.v1.GetSharedParametersRequest
 */
export type GetSharedParametersRequest = Message<"pipeex.sharedparameter.v1.GetSharedParametersRequest"> & {
};

/**
 * Describes the message pipeex.sharedparameter.v1.GetSharedParametersRequest.
 * Use `create(GetSharedParametersRequestSchema)` to create a new message.
 */
export const GetSharedParametersRequestSchema: GenMessage<GetSharedParametersRequest> = /*@__PURE__*/
  messageDesc(file_shared_parameter_service, 0);

/**
 * @generated from message pipeex.sharedparameter.v1.SharedParameterDto
 */
export type SharedParameterDto = Message<"pipeex.sharedparameter.v1.SharedParameterDto"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string guid = 2;
   */
  guid: string;

  /**
   * @generated from field: string group = 3;
   */
  group: string;

  /**
   * @generated from field: string data_type = 4;
   */
  dataType: string;

  /**
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * @generated from field: bool visible = 6;
   */
  visible: boolean;
};

/**
 * Describes the message pipeex.sharedparameter.v1.SharedParameterDto.
 * Use `create(SharedParameterDtoSchema)` to create a new message.
 */
export const SharedParameterDtoSchema: GenMessage<SharedParameterDto> = /*@__PURE__*/
  messageDesc(file_shared_parameter_service, 1);

/**
 * @generated from message pipeex.sharedparameter.v1.GetSharedParametersResponse
 */
export type GetSharedParametersResponse = Message<"pipeex.sharedparameter.v1.GetSharedParametersResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: repeated pipeex.sharedparameter.v1.SharedParameterDto parameters = 3;
   */
  parameters: SharedParameterDto[];
};

/**
 * Describes the message pipeex.sharedparameter.v1.GetSharedParametersResponse.
 * Use `create(GetSharedParametersResponseSchema)` to create a new message.
 */
export const GetSharedParametersResponseSchema: GenMessage<GetSharedParametersResponse> = /*@__PURE__*/
  messageDesc(file_shared_parameter_service, 2);

/**
 * @generated from message pipeex.sharedparameter.v1.LoadSharedParameterFileRequest
 */
export type LoadSharedParameterFileRequest = Message<"pipeex.sharedparameter.v1.LoadSharedParameterFileRequest"> & {
  /**
   * Full file path. Empty = use Revit's current default.
   *
   * @generated from field: string file_path = 1;
   */
  filePath: string;
};

/**
 * Describes the message pipeex.sharedparameter.v1.LoadSharedParameterFileRequest.
 * Use `create(LoadSharedParameterFileRequestSchema)` to create a new message.
 */
export const LoadSharedParameterFileRequestSchema: GenMessage<LoadSharedParameterFileRequest> = /*@__PURE__*/
  messageDesc(file_shared_parameter_service, 3);

/**
 * @generated from message pipeex.sharedparameter.v1.SharedParameterDefinitionDto
 */
export type SharedParameterDefinitionDto = Message<"pipeex.sharedparameter.v1.SharedParameterDefinitionDto"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string guid = 2;
   */
  guid: string;

  /**
   * @generated from field: string group = 3;
   */
  group: string;

  /**
   * @generated from field: string data_type = 4;
   */
  dataType: string;

  /**
   * @generated from field: string parameter_type = 5;
   */
  parameterType: string;

  /**
   * @generated from field: string description = 6;
   */
  description: string;

  /**
   * @generated from field: bool visible = 7;
   */
  visible: boolean;
};

/**
 * Describes the message pipeex.sharedparameter.v1.SharedParameterDefinitionDto.
 * Use `create(SharedParameterDefinitionDtoSchema)` to create a new message.
 */
export const SharedParameterDefinitionDtoSchema: GenMessage<SharedParameterDefinitionDto> = /*@__PURE__*/
  messageDesc(file_shared_parameter_service, 4);

/**
 * @generated from message pipeex.sharedparameter.v1.LoadSharedParameterFileResponse
 */
export type LoadSharedParameterFileResponse = Message<"pipeex.sharedparameter.v1.LoadSharedParameterFileResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: string file_path = 3;
   */
  filePath: string;

  /**
   * @generated from field: int32 parameter_count = 4;
   */
  parameterCount: number;

  /**
   * @generated from field: repeated pipeex.sharedparameter.v1.SharedParameterDefinitionDto parameters = 5;
   */
  parameters: SharedParameterDefinitionDto[];
};

/**
 * Describes the message pipeex.sharedparameter.v1.LoadSharedParameterFileResponse.
 * Use `create(LoadSharedParameterFileResponseSchema)` to create a new message.
 */
export const LoadSharedParameterFileResponseSchema: GenMessage<LoadSharedParameterFileResponse> = /*@__PURE__*/
  messageDesc(file_shared_parameter_service, 5);

/**
 * @generated from message pipeex.sharedparameter.v1.CreateTypeParametersRequest
 */
export type CreateTypeParametersRequest = Message<"pipeex.sharedparameter.v1.CreateTypeParametersRequest"> & {
  /**
   * @generated from field: repeated string parameter_names = 1;
   */
  parameterNames: string[];

  /**
   * Category names: "PIPES", "PIPE FITTINGS", "PIPE ACCESSORIES"
   *
   * @generated from field: repeated string categories = 2;
   */
  categories: string[];

  /**
   * Optional path to shared parameter file
   *
   * @generated from field: string shared_param_file = 3;
   */
  sharedParamFile: string;

  /**
   * @generated from field: string expected_document_name = 4;
   */
  expectedDocumentName: string;

  /**
   * @generated from field: string expected_document_path = 5;
   */
  expectedDocumentPath: string;
};

/**
 * Describes the message pipeex.sharedparameter.v1.CreateTypeParametersRequest.
 * Use `create(CreateTypeParametersRequestSchema)` to create a new message.
 */
export const CreateTypeParametersRequestSchema: GenMessage<CreateTypeParametersRequest> = /*@__PURE__*/
  messageDesc(file_shared_parameter_service, 6);

/**
 * @generated from message pipeex.sharedparameter.v1.ParameterCreationResultDto
 */
export type ParameterCreationResultDto = Message<"pipeex.sharedparameter.v1.ParameterCreationResultDto"> & {
  /**
   * @generated from field: string parameter = 1;
   */
  parameter: string;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;

  /**
   * @generated from field: string message = 3;
   */
  message: string;

  /**
   * @generated from field: string error = 4;
   */
  error: string;

  /**
   * @generated from field: string guid = 5;
   */
  guid: string;

  /**
   * @generated from field: repeated string categories = 6;
   */
  categories: string[];

  /**
   * Exact terminal outcome: Created, Updated, AlreadyExistsCompatible, Conflict, or Failed.
   *
   * @generated from field: string status = 7;
   */
  status: string;
};

/**
 * Describes the message pipeex.sharedparameter.v1.ParameterCreationResultDto.
 * Use `create(ParameterCreationResultDtoSchema)` to create a new message.
 */
export const ParameterCreationResultDtoSchema: GenMessage<ParameterCreationResultDto> = /*@__PURE__*/
  messageDesc(file_shared_parameter_service, 7);

/**
 * @generated from message pipeex.sharedparameter.v1.CreateTypeParametersResponse
 */
export type CreateTypeParametersResponse = Message<"pipeex.sharedparameter.v1.CreateTypeParametersResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: int32 success_count = 3;
   */
  successCount: number;

  /**
   * @generated from field: int32 failure_count = 4;
   */
  failureCount: number;

  /**
   * @generated from field: int32 total_count = 5;
   */
  totalCount: number;

  /**
   * @generated from field: repeated pipeex.sharedparameter.v1.ParameterCreationResultDto results = 6;
   */
  results: ParameterCreationResultDto[];
};

/**
 * Describes the message pipeex.sharedparameter.v1.CreateTypeParametersResponse.
 * Use `create(CreateTypeParametersResponseSchema)` to create a new message.
 */
export const CreateTypeParametersResponseSchema: GenMessage<CreateTypeParametersResponse> = /*@__PURE__*/
  messageDesc(file_shared_parameter_service, 8);

/**
 * @generated from message pipeex.sharedparameter.v1.AddParametersToAllFamiliesRequest
 */
export type AddParametersToAllFamiliesRequest = Message<"pipeex.sharedparameter.v1.AddParametersToAllFamiliesRequest"> & {
  /**
   * JSON-serialized ParameterAdditionPayload.
   * Supports both simple string[] of names and full payload with categories,
   * sharedParameterFilePath, bindingKind, etc.
   *
   * @generated from field: string payload_json = 1;
   */
  payloadJson: string;
};

/**
 * Describes the message pipeex.sharedparameter.v1.AddParametersToAllFamiliesRequest.
 * Use `create(AddParametersToAllFamiliesRequestSchema)` to create a new message.
 */
export const AddParametersToAllFamiliesRequestSchema: GenMessage<AddParametersToAllFamiliesRequest> = /*@__PURE__*/
  messageDesc(file_shared_parameter_service, 9);

/**
 * @generated from message pipeex.sharedparameter.v1.ModifiedFamilyDto
 */
export type ModifiedFamilyDto = Message<"pipeex.sharedparameter.v1.ModifiedFamilyDto"> & {
  /**
   * @generated from field: string family_name = 1;
   */
  familyName: string;

  /**
   * @generated from field: string family_id = 2;
   */
  familyId: string;

  /**
   * @generated from field: string category = 3;
   */
  category: string;

  /**
   * @generated from field: repeated string added_parameters = 4;
   */
  addedParameters: string[];
};

/**
 * Describes the message pipeex.sharedparameter.v1.ModifiedFamilyDto.
 * Use `create(ModifiedFamilyDtoSchema)` to create a new message.
 */
export const ModifiedFamilyDtoSchema: GenMessage<ModifiedFamilyDto> = /*@__PURE__*/
  messageDesc(file_shared_parameter_service, 10);

/**
 * @generated from message pipeex.sharedparameter.v1.AddParametersToAllFamiliesResponse
 */
export type AddParametersToAllFamiliesResponse = Message<"pipeex.sharedparameter.v1.AddParametersToAllFamiliesResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: int32 modified_families_count = 3;
   */
  modifiedFamiliesCount: number;

  /**
   * @generated from field: repeated pipeex.sharedparameter.v1.ModifiedFamilyDto modified_families = 4;
   */
  modifiedFamilies: ModifiedFamilyDto[];

  /**
   * @generated from field: string message = 5;
   */
  message: string;

  /**
   * If the request was queued via ExternalEvent
   *
   * @generated from field: string status = 6;
   */
  status: string;

  /**
   * @generated from field: string request_id = 7;
   */
  requestId: string;
};

/**
 * Describes the message pipeex.sharedparameter.v1.AddParametersToAllFamiliesResponse.
 * Use `create(AddParametersToAllFamiliesResponseSchema)` to create a new message.
 */
export const AddParametersToAllFamiliesResponseSchema: GenMessage<AddParametersToAllFamiliesResponse> = /*@__PURE__*/
  messageDesc(file_shared_parameter_service, 11);

/**
 * @generated from message pipeex.sharedparameter.v1.AddProjectParametersRequest
 */
export type AddProjectParametersRequest = Message<"pipeex.sharedparameter.v1.AddProjectParametersRequest"> & {
  /**
   * @generated from field: repeated string parameter_names = 1;
   */
  parameterNames: string[];

  /**
   * Category names: "Pipes", "Pipe Fittings", "Pipe Accessories"
   *
   * @generated from field: repeated string categories = 2;
   */
  categories: string[];

  /**
   * @generated from field: string expected_document_name = 3;
   */
  expectedDocumentName: string;

  /**
   * @generated from field: string expected_document_path = 4;
   */
  expectedDocumentPath: string;

  /**
   * Data type hints (shared parameter file DATA tokens) used when a
   * requested parameter is missing from the shared parameter file and must
   * be created ad-hoc.
   *
   * @generated from field: repeated pipeex.revit.v1.ParameterDataTypeHint parameter_type_hints = 5;
   */
  parameterTypeHints: ParameterDataTypeHint[];

  /**
   * Explicit project binding requested by the UI: "type" or "instance".
   * Older clients omit this field and retain category-based inference.
   *
   * @generated from field: string binding_kind = 6;
   */
  bindingKind: string;
};

/**
 * Describes the message pipeex.sharedparameter.v1.AddProjectParametersRequest.
 * Use `create(AddProjectParametersRequestSchema)` to create a new message.
 */
export const AddProjectParametersRequestSchema: GenMessage<AddProjectParametersRequest> = /*@__PURE__*/
  messageDesc(file_shared_parameter_service, 12);

/**
 * @generated from message pipeex.sharedparameter.v1.AddProjectParametersResponse
 */
export type AddProjectParametersResponse = Message<"pipeex.sharedparameter.v1.AddProjectParametersResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: int32 added_parameters_count = 3;
   */
  addedParametersCount: number;

  /**
   * @generated from field: repeated string added_parameters = 4;
   */
  addedParameters: string[];

  /**
   * @generated from field: repeated string categories = 5;
   */
  categories: string[];

  /**
   * @generated from field: string message = 6;
   */
  message: string;

  /**
   * Per-parameter terminal outcome for every requested parameter, in request order.
   *
   * @generated from field: repeated pipeex.sharedparameter.v1.ParameterCreationResultDto results = 7;
   */
  results: ParameterCreationResultDto[];

  /**
   * Revit-authored compensation state for every binding actually mutated.
   *
   * @generated from field: repeated pipeex.parameterundo.v1.ProjectParameterUndoEntry undo_entries = 8;
   */
  undoEntries: ProjectParameterUndoEntry[];
};

/**
 * Describes the message pipeex.sharedparameter.v1.AddProjectParametersResponse.
 * Use `create(AddProjectParametersResponseSchema)` to create a new message.
 */
export const AddProjectParametersResponseSchema: GenMessage<AddProjectParametersResponse> = /*@__PURE__*/
  messageDesc(file_shared_parameter_service, 13);

/**
 * @generated from message pipeex.sharedparameter.v1.UndoAddedProjectParametersRequest
 */
export type UndoAddedProjectParametersRequest = Message<"pipeex.sharedparameter.v1.UndoAddedProjectParametersRequest"> & {
  /**
   * @generated from field: repeated string parameter_names = 1;
   */
  parameterNames: string[];

  /**
   * @generated from field: string expected_document_name = 2;
   */
  expectedDocumentName: string;

  /**
   * @generated from field: string expected_document_path = 3;
   */
  expectedDocumentPath: string;

  /**
   * Preferred over parameter_names. Older clients may still send names only.
   *
   * @generated from field: repeated pipeex.parameterundo.v1.ProjectParameterUndoEntry entries = 4;
   */
  entries: ProjectParameterUndoEntry[];
};

/**
 * Describes the message pipeex.sharedparameter.v1.UndoAddedProjectParametersRequest.
 * Use `create(UndoAddedProjectParametersRequestSchema)` to create a new message.
 */
export const UndoAddedProjectParametersRequestSchema: GenMessage<UndoAddedProjectParametersRequest> = /*@__PURE__*/
  messageDesc(file_shared_parameter_service, 14);

/**
 * @generated from message pipeex.sharedparameter.v1.UndoAddedProjectParametersResponse
 */
export type UndoAddedProjectParametersResponse = Message<"pipeex.sharedparameter.v1.UndoAddedProjectParametersResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: int32 removed_parameter_count = 3;
   */
  removedParameterCount: number;

  /**
   * @generated from field: repeated string errors = 4;
   */
  errors: string[];

  /**
   * @generated from field: string message = 5;
   */
  message: string;

  /**
   * @generated from field: int32 restored_parameter_count = 6;
   */
  restoredParameterCount: number;
};

/**
 * Describes the message pipeex.sharedparameter.v1.UndoAddedProjectParametersResponse.
 * Use `create(UndoAddedProjectParametersResponseSchema)` to create a new message.
 */
export const UndoAddedProjectParametersResponseSchema: GenMessage<UndoAddedProjectParametersResponse> = /*@__PURE__*/
  messageDesc(file_shared_parameter_service, 15);

/**
 * @generated from message pipeex.sharedparameter.v1.DeleteAndReAddParameterRequest
 */
export type DeleteAndReAddParameterRequest = Message<"pipeex.sharedparameter.v1.DeleteAndReAddParameterRequest"> & {
  /**
   * @generated from field: string old_param_name = 1;
   */
  oldParamName: string;

  /**
   * @generated from field: string new_param_name = 2;
   */
  newParamName: string;

  /**
   * @generated from field: repeated string categories = 3;
   */
  categories: string[];

  /**
   * @generated from field: string expected_document_name = 4;
   */
  expectedDocumentName: string;

  /**
   * @generated from field: string expected_document_path = 5;
   */
  expectedDocumentPath: string;
};

/**
 * Describes the message pipeex.sharedparameter.v1.DeleteAndReAddParameterRequest.
 * Use `create(DeleteAndReAddParameterRequestSchema)` to create a new message.
 */
export const DeleteAndReAddParameterRequestSchema: GenMessage<DeleteAndReAddParameterRequest> = /*@__PURE__*/
  messageDesc(file_shared_parameter_service, 16);

/**
 * @generated from message pipeex.sharedparameter.v1.DeleteAndReAddParameterResponse
 */
export type DeleteAndReAddParameterResponse = Message<"pipeex.sharedparameter.v1.DeleteAndReAddParameterResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: string old_parameter = 3;
   */
  oldParameter: string;

  /**
   * @generated from field: string new_parameter = 4;
   */
  newParameter: string;

  /**
   * @generated from field: repeated string categories = 5;
   */
  categories: string[];

  /**
   * @generated from field: repeated string warnings = 6;
   */
  warnings: string[];
};

/**
 * Describes the message pipeex.sharedparameter.v1.DeleteAndReAddParameterResponse.
 * Use `create(DeleteAndReAddParameterResponseSchema)` to create a new message.
 */
export const DeleteAndReAddParameterResponseSchema: GenMessage<DeleteAndReAddParameterResponse> = /*@__PURE__*/
  messageDesc(file_shared_parameter_service, 17);

/**
 * @generated from message pipeex.sharedparameter.v1.ParsedParameterInput
 */
export type ParsedParameterInput = Message<"pipeex.sharedparameter.v1.ParsedParameterInput"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string guid = 2;
   */
  guid: string;

  /**
   * @generated from field: string data_type = 3;
   */
  dataType: string;

  /**
   * @generated from field: int32 group_id = 4;
   */
  groupId: number;

  /**
   * @generated from field: string description = 5;
   */
  description: string;
};

/**
 * Describes the message pipeex.sharedparameter.v1.ParsedParameterInput.
 * Use `create(ParsedParameterInputSchema)` to create a new message.
 */
export const ParsedParameterInputSchema: GenMessage<ParsedParameterInput> = /*@__PURE__*/
  messageDesc(file_shared_parameter_service, 18);

/**
 * @generated from message pipeex.sharedparameter.v1.CreateParametersFromParsedFileRequest
 */
export type CreateParametersFromParsedFileRequest = Message<"pipeex.sharedparameter.v1.CreateParametersFromParsedFileRequest"> & {
  /**
   * @generated from field: repeated pipeex.sharedparameter.v1.ParsedParameterInput parameters = 1;
   */
  parameters: ParsedParameterInput[];

  /**
   * Category names to apply parameters to
   *
   * @generated from field: repeated string categories = 2;
   */
  categories: string[];

  /**
   * true = Type parameters, false = Instance parameters
   *
   * @generated from field: bool is_type = 3;
   */
  isType: boolean;

  /**
   * @generated from field: string expected_document_name = 4;
   */
  expectedDocumentName: string;

  /**
   * @generated from field: string expected_document_path = 5;
   */
  expectedDocumentPath: string;
};

/**
 * Describes the message pipeex.sharedparameter.v1.CreateParametersFromParsedFileRequest.
 * Use `create(CreateParametersFromParsedFileRequestSchema)` to create a new message.
 */
export const CreateParametersFromParsedFileRequestSchema: GenMessage<CreateParametersFromParsedFileRequest> = /*@__PURE__*/
  messageDesc(file_shared_parameter_service, 19);

/**
 * @generated from message pipeex.sharedparameter.v1.CreateParametersFromParsedFileResponse
 */
export type CreateParametersFromParsedFileResponse = Message<"pipeex.sharedparameter.v1.CreateParametersFromParsedFileResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: int32 success_count = 3;
   */
  successCount: number;

  /**
   * @generated from field: int32 failure_count = 4;
   */
  failureCount: number;

  /**
   * @generated from field: int32 total_count = 5;
   */
  totalCount: number;

  /**
   * @generated from field: repeated pipeex.sharedparameter.v1.ParameterCreationResultDto results = 6;
   */
  results: ParameterCreationResultDto[];

  /**
   * Revit-authored compensation state for every binding actually mutated.
   *
   * @generated from field: repeated pipeex.parameterundo.v1.ProjectParameterUndoEntry undo_entries = 7;
   */
  undoEntries: ProjectParameterUndoEntry[];
};

/**
 * Describes the message pipeex.sharedparameter.v1.CreateParametersFromParsedFileResponse.
 * Use `create(CreateParametersFromParsedFileResponseSchema)` to create a new message.
 */
export const CreateParametersFromParsedFileResponseSchema: GenMessage<CreateParametersFromParsedFileResponse> = /*@__PURE__*/
  messageDesc(file_shared_parameter_service, 20);

/**
 * Shared parameter file management and parameter creation operations.
 * Replaces the WebView2 RevitBridge shared-parameter surface
 * (GetSharedParameters, LoadSharedParameterFile, CreateTypeParameters,
 *  AddParametersToAllFamilies, AddProjectParameters, DeleteAndReAddParameter,
 *  CreateParametersFromParsedFile).
 *
 * @generated from service pipeex.sharedparameter.v1.SharedParameterService
 */
export const SharedParameterService: GenService<{
  /**
   * Get all parameters defined in the active shared parameter file.
   *
   * @generated from rpc pipeex.sharedparameter.v1.SharedParameterService.GetSharedParameters
   */
  getSharedParameters: {
    methodKind: "unary";
    input: typeof GetSharedParametersRequestSchema;
    output: typeof GetSharedParametersResponseSchema;
  },
  /**
   * Load and parse a shared parameter file. Empty path = Revit's default file.
   *
   * @generated from rpc pipeex.sharedparameter.v1.SharedParameterService.LoadSharedParameterFile
   */
  loadSharedParameterFile: {
    methodKind: "unary";
    input: typeof LoadSharedParameterFileRequestSchema;
    output: typeof LoadSharedParameterFileResponseSchema;
  },
  /**
   * Start shared-parameter file loading as a host operation with live progress.
   *
   * @generated from rpc pipeex.sharedparameter.v1.SharedParameterService.StartLoadSharedParameterFile
   */
  startLoadSharedParameterFile: {
    methodKind: "unary";
    input: typeof LoadSharedParameterFileRequestSchema;
    output: typeof StartOperationResponseSchema;
  },
  /**
   * Create TYPE parameters from shared parameter definitions.
   *
   * @generated from rpc pipeex.sharedparameter.v1.SharedParameterService.CreateTypeParameters
   */
  createTypeParameters: {
    methodKind: "unary";
    input: typeof CreateTypeParametersRequestSchema;
    output: typeof CreateTypeParametersResponseSchema;
  },
  /**
   * Start TYPE parameter creation as a host operation with live progress.
   *
   * @generated from rpc pipeex.sharedparameter.v1.SharedParameterService.StartCreateTypeParameters
   */
  startCreateTypeParameters: {
    methodKind: "unary";
    input: typeof CreateTypeParametersRequestSchema;
    output: typeof StartOperationResponseSchema;
  },
  /**
   * Add specified parameters to all families in pipe-related categories.
   *
   * @generated from rpc pipeex.sharedparameter.v1.SharedParameterService.AddParametersToAllFamilies
   */
  addParametersToAllFamilies: {
    methodKind: "unary";
    input: typeof AddParametersToAllFamiliesRequestSchema;
    output: typeof AddParametersToAllFamiliesResponseSchema;
  },
  /**
   * Start add-to-all-families parameter creation as a host operation with live progress.
   *
   * @generated from rpc pipeex.sharedparameter.v1.SharedParameterService.StartAddParametersToAllFamilies
   */
  startAddParametersToAllFamilies: {
    methodKind: "unary";
    input: typeof AddParametersToAllFamiliesRequestSchema;
    output: typeof StartOperationResponseSchema;
  },
  /**
   * Add project-level parameters that apply to all elements of specified categories.
   *
   * @generated from rpc pipeex.sharedparameter.v1.SharedParameterService.AddProjectParameters
   */
  addProjectParameters: {
    methodKind: "unary";
    input: typeof AddProjectParametersRequestSchema;
    output: typeof AddProjectParametersResponseSchema;
  },
  /**
   * Start project parameter setup as a host operation with live progress.
   *
   * @generated from rpc pipeex.sharedparameter.v1.SharedParameterService.StartAddProjectParameters
   */
  startAddProjectParameters: {
    methodKind: "unary";
    input: typeof AddProjectParametersRequestSchema;
    output: typeof StartOperationResponseSchema;
  },
  /**
   * Undo newly added project parameters by removing their bindings.
   *
   * @generated from rpc pipeex.sharedparameter.v1.SharedParameterService.UndoAddedProjectParameters
   */
  undoAddedProjectParameters: {
    methodKind: "unary";
    input: typeof UndoAddedProjectParametersRequestSchema;
    output: typeof UndoAddedProjectParametersResponseSchema;
  },
  /**
   * Start project parameter undo as a host operation with live progress.
   *
   * @generated from rpc pipeex.sharedparameter.v1.SharedParameterService.StartUndoAddedProjectParameters
   */
  startUndoAddedProjectParameters: {
    methodKind: "unary";
    input: typeof UndoAddedProjectParametersRequestSchema;
    output: typeof StartOperationResponseSchema;
  },
  /**
   * Delete an existing parameter and create a new one. WARNING: data is lost.
   *
   * @generated from rpc pipeex.sharedparameter.v1.SharedParameterService.DeleteAndReAddParameter
   */
  deleteAndReAddParameter: {
    methodKind: "unary";
    input: typeof DeleteAndReAddParameterRequestSchema;
    output: typeof DeleteAndReAddParameterResponseSchema;
  },
  /**
   * Start delete-and-readd as a host operation with live progress.
   *
   * @generated from rpc pipeex.sharedparameter.v1.SharedParameterService.StartDeleteAndReAddParameter
   */
  startDeleteAndReAddParameter: {
    methodKind: "unary";
    input: typeof DeleteAndReAddParameterRequestSchema;
    output: typeof StartOperationResponseSchema;
  },
  /**
   * Create Revit parameters from pre-parsed shared parameter file data.
   *
   * @generated from rpc pipeex.sharedparameter.v1.SharedParameterService.CreateParametersFromParsedFile
   */
  createParametersFromParsedFile: {
    methodKind: "unary";
    input: typeof CreateParametersFromParsedFileRequestSchema;
    output: typeof CreateParametersFromParsedFileResponseSchema;
  },
  /**
   * Start parsed shared-parameter creation as a host operation with live progress.
   *
   * @generated from rpc pipeex.sharedparameter.v1.SharedParameterService.StartCreateParametersFromParsedFile
   */
  startCreateParametersFromParsedFile: {
    methodKind: "unary";
    input: typeof CreateParametersFromParsedFileRequestSchema;
    output: typeof StartOperationResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_shared_parameter_service, 0);

